import { gql } from '@apollo/client';
import { ActionFragment } from 'graphql/Action/fragments/ActionFragment';
/**
 * @fragment PermissionFragment
 * @since 1.0.0
 */
export const PermissionFragment = gql `
  fragment PermissionFragment on Permission {
    id
    status
    createdAt
    updatedAt

    action {
      ...ActionFragment
    }
  }

  ${ActionFragment}
`;
